"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var SpotcontractsIcon = function SpotcontractsIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-id": "icon-spot-contracts",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: props.width || "70px",
    height: props.height || "70px"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "80.5",
    cy: "15.5",
    r: "2.5"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M48,96A48,48,0,1,1,75.57,8.72,2,2,0,1,1,73.27,12,44,44,0,1,0,84,22.73a2,2,0,1,1,3.27-2.3A48,48,0,0,1,48,96Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M76.24,55.76a6.14,6.14,0,0,0-6.37-1.32L53.2,35a6,6,0,0,0-1-7.23,6.13,6.13,0,0,0-8.48,0,6,6,0,0,0-1,7.23L26.13,54.44a6.13,6.13,0,0,0-6.37,1.32A6,6,0,1,0,29.2,57L45.84,37.59a5.89,5.89,0,0,0,4.32,0L66.8,57a6,6,0,1,0,9.44-1.25ZM25.41,61.41a2,2,0,0,1-2.82,0,2,2,0,1,1,2.82,0Zm21.18-28a2,2,0,1,1,2.82,0A2,2,0,0,1,46.59,33.41Z"
  }))));
};

var _default = SpotcontractsIcon;
exports["default"] = _default;